"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navbar_component_1 = __importDefault(require("./navbar.component"));
exports.default = navbar_component_1.default;
